import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dismissQuickstart: {
		id: 'polaris-components-quickstart.onboarding-check-list.dismiss-pill.non-final',
		defaultMessage: 'Dismiss Quickstart',
		description: 'Dismiss button for the quickstart onboarding checklist',
	},
	title: {
		id: 'polaris-components-quickstart.onboarding-check-list.title.non-final',
		defaultMessage: 'Quickstart',
		description: 'The title of the Quickstart panel, displayed in the sidebar header',
	},
});
